import { useIntl } from 'react-intl';
import { showNotification } from '../components/molecules/Notifications';
import { Basket } from './checkoutState';

const getMinimalItems = (basket: Basket) =>
  basket.packages.flatMap(pkg => pkg.items).map(({ variantId, quantity }) => ({ variantId, quantity }));

const useBasketNotifications = () => {
  const { formatMessage } = useIntl();

  const triggerBasketUpdateNotification = (nextBasket: Basket, prevBasket?: Basket) => {
    if (!prevBasket) {
      return;
    }
    const nextItems = getMinimalItems(nextBasket);
    const prevItems = getMinimalItems(prevBasket);
    const isDifferent = JSON.stringify(nextItems) !== JSON.stringify(prevItems);
    if (isDifferent) {
      showNotification({
        level: 'info',
        text: formatMessage({ id: 'basket.notifications.basketUpdated' }),
        autoClose: true,
      });
    }
  };

  const triggerBasketEmptyNotification = () =>
    showNotification({
      level: 'error',
      text: formatMessage({ id: 'basket.notifications.basketEmpty' }),
      autoClose: true,
    });

  return { triggerBasketUpdateNotification, triggerBasketEmptyNotification };
};

export default useBasketNotifications;
